import React, { Component } from 'react';
import {
  Route,
  Redirect
} from 'react-router-dom';
import { ConnectedRouter as Router } from 'react-router-redux'
import createHistory from 'history/createBrowserHistory'
import { history } from 'state/store';

import { AnimatedSwitch } from 'react-router-transition';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import HomeContainer from 'containers/HomeContainer';
import QuestionnaireContainer from 'containers/QuestionnaireContainer';
import QualifyContainer from 'containers/QualifyContainer';
import BonusContainer from 'containers/BonusContainer';
import TermsContainer from 'containers/TermsContainer';

import Nav from 'components/Nav';
import StickyNav from 'components/StickyNav';
import ProgressBar from 'components/ProgressBar';
import WaveBackground from 'components/WaveBackground';
import Modal from 'components/Modal';
import VideoOverlay from 'components/VideoOverlay';
import get from 'utils/get';
import SegmentWrapper from 'lib/segment';

class App extends Component {

  componentDidMount() {
    document.getElementsByTagName('body')[0].classList.remove('loading');
  }

  ensureEmailDataPresent = AttemptedContainer => {
    let emailDidSucceed = get(this, 'props.emailState.success', false);
    if (emailDidSucceed) return <AttemptedContainer />;
    return <Redirect to={'/'} />;
  }

  render() {
    return (
      <Router history={history}>
        <div>
          <Nav />
          <StickyNav />
          <ProgressBar />
          <Modal />
          <VideoOverlay />
          <AnimatedSwitch
            atEnter={{ opacity: 0 }}
            atLeave={{ opacity: 0 }}
            atActive={{ opacity: 1 }}
            className="switch-wrapper"
          >
            <Route exact path="/" component={HomeContainer}/>
            <Route
              exact
              path="/questionnaire"
              render={() => this.ensureEmailDataPresent(QuestionnaireContainer)}
            />
            <Route
              exact
              path="/qualify"
              render={() => this.ensureEmailDataPresent(QualifyContainer)}
            />
            <Route
              exact
              path="/bonus"
              render={() => this.ensureEmailDataPresent(BonusContainer)}
            />
            <Route exact path="/terms" component={TermsContainer} />
          </AnimatedSwitch>
          <WaveBackground />
        </div>
      </Router>
    );
  }
};

function mapStateToProps(state) {
  return {
    emailState: state.applicationState.submitEmail
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
      },
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/App.js